import React from 'react'
import { Footer } from '../../../common/footer/footer';
import { Pagination } from '../../../common/pagination/pagination';
import Sidebar from "../sidebar/sidebar.js";
import { ModulePermission } from '../../../../shared/helper'

const ProductsJsx = (props) => {
    const {
        offerData,
        wholeData,
        categoryData,
        formData,
        onInputChange,
        onTouchHandler,
        onPaginationButtonClick,
        onSubmitButtonClick,
        handleChange, handleChange1, handleChange2, resetPagination
    } = props;

    return (
        <>
            <section className="entiredashboard admindashboard">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-sm-3">


                            <div className="dashboardleftpanel martop40">

                                <div className="dashboardlink martop40">
                                    <Sidebar />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9 col-sm-9">
                            <div className="dashboardrightpanel martop40">
                                <section classname="addexpertformsec">
                                    <div className="myadssection">
                                        <h2 className="h2_style martop30">Manage Products</h2>
                                        <p>Morem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                                    </div>
                                    <div className="myexpertformarea searcharea martop40">
                                        <div className="input-container form-group">
                                            <select className="input form-control form-select" placeholder=" " name="type"
                                                onChange={onInputChange}
                                                onBlur={onTouchHandler}>
                                                <option value="Elite">Elite</option>
                                                <option value="Premium">Premium</option>
                                            </select>
                                            <div className="placeholder">Type</div>
                                        </div>
                                        <div className="input-container form-group">
                                            <input type="text" className="form-control input" placeholder=" " name="instituteName"
                                                onChange={onInputChange}
                                                onBlur={onTouchHandler}
                                                value={formData.name} />
                                            <div className="placeholder">Institution Name</div>
                                        </div>
                                        <div className="input-container form-group">
                                            <select className="input form-control form-select" placeholder=" " name="institutionCategory"
                                                onChange={onInputChange}
                                                onBlur={onTouchHandler}>
                                                <option value="">All</option>
                                                {categoryData?.map((item) => {
                                                    return (
                                                        <>

                                                            <option value={item.institutionCategoryId}>{item.name}</option>
                                                        </>
                                                    )
                                                })}
                                            </select>
                                            <div className="placeholder">Category</div>
                                        </div>
                                        <div className="input-container form-group">
                                            <input type="text" className="form-control input" placeholder=" " name="productName"
                                                onChange={onInputChange}
                                                onBlur={onTouchHandler}
                                                value={formData.name} />
                                            <div className="placeholder">Product name of offer</div>
                                        </div>
                                        <div className="input-container form-group">
                                            <select className="input form-control form-select" placeholder=" " name="homeFeatured"
                                                onChange={onInputChange}
                                                onBlur={onTouchHandler}>
                                                <option value="">All</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </select>
                                            <div className="placeholder">Featured</div>
                                        </div>
                                        <div className="input-container form-group">
                                            <button type="submit" className="ctaonebutton" onClick={() => onSubmitButtonClick()}>Search</button>
                                        </div>
                                    </div>
                                    <div className="searchdetails">
                                        <table className="searchdetailsdb">
                                            <tr>
                                                <th>Institution Name</th>
                                                <th>Product Name</th>
                                                <th>Description</th>
                                                <th>Category</th>
                                                <th>Featured</th>
                                                <th>Top Products</th>
                                                <th>Home Featured</th>
                                                <th>Comission</th>
                                                <th>Action</th>
                                            </tr>

                                            {

                                                offerData?.map(data => {
                                                    return <tr>
                                                        <td>{data.institute.name}</td>
                                                        <td>{data.productName}</td>
                                                        <td>{data.description}</td>
                                                        <td>{data.parentInstitutionCategory}</td>
                                                        <td><input disabled={ModulePermission().canReadProduct} type="checkbox" checked={data?.isFeatured} onChange={e => handleChange(e, data.institutionProductId)} /></td>
                                                        <td><input disabled={ModulePermission().canReadProduct} type="checkbox" checked={data.isTopProduct} onChange={e => handleChange1(e, data.institutionProductId)} /></td>

                                                        <td><input disabled={ModulePermission().canReadProduct} type="checkbox" checked={data.isHomeFeatured} onChange={e => handleChange2(e, data.institutionProductId)} /> </td>

                                                        <td><input disabled={ModulePermission().canReadProduct} /></td>
                                                        <td><button disabled={ModulePermission().canReadProduct} type="submit" className="ctaonebutton">Save</button></td>
                                                    </tr>
                                                })
                                            }

                                        </table>
                                    </div>
                                </section>
                            </div>
                        </div>

                    </div>
                    {offerData?.length > 0 && <Pagination
                        limit={10}
                        resetPagi={resetPagination}
                        totalCount={wholeData?.meta?.totalCount}
                        onPaginationButtonClick={onPaginationButtonClick}
                    />}
                </div>
            </section>
            <Footer />

        </>

    );
};

export default ProductsJsx;
